var _path, _path2, _ellipse, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 80,
    viewBox: "0 0 93 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.4613 23.024L90.131 23.024C91.3286 23.024 92.2578 24.0694 92.1172 25.2588L85.8545 78.2351C85.7355 79.2419 84.8821 80.0004 83.8684 80.0004H14.9319C13.7358 80.0004 12.8071 78.9574 12.9453 77.7693L17.6759 37.0888C17.2829 36.9025 17.0363 36.4686 17.1196 36.0067L19.0368 25.3863L19.1058 24.7929C19.1269 24.6116 19.1718 24.4382 19.2373 24.2758L20.0812 19.6007C20.1671 19.1246 20.5815 18.7783 21.0653 18.7783L55.8737 18.7783C56.1942 18.7783 56.4953 18.9319 56.6834 19.1914L59.4613 23.024Z",
    fill: "#3F58E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5393 41.1212C82.1371 43.6345 80.2313 46.0469 77.6479 46.0469L18.019 46.0469C16.1664 46.0469 14.5562 44.7748 14.1275 42.9725L5.07753 4.92568C4.4797 2.4124 6.38555 4.49629e-05 8.96895 4.48613e-05L68.5979 4.25166e-05C70.4504 4.24438e-05 72.0606 1.27213 72.4893 3.07441L81.5393 41.1212Z",
    fill: "#74FFFF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.22437,
    cy: 9.7831,
    rx: 8.22437,
    ry: 9.7831,
    transform: "matrix(0.961912 -0.273359 0.33134 0.943512 11.1934 10.8818)",
    fill: "#5333D3"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4568 78.7684C85.6064 79.3968 85.1299 80 84.484 80L14.2468 80C13.3207 80 12.5157 79.3642 12.3012 78.4632L1.45617 32.9083C1.15699 31.6515 2.10994 30.4451 3.4018 30.4451L72.3729 30.4451C73.2991 30.4451 74.1041 31.0809 74.3186 31.9819L85.4568 78.7684Z",
    fill: "url(#paint0_linear_1926_2538)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1926_2538",
    x1: 85.5005,
    y1: 80,
    x2: 41.8934,
    y2: 5.70472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F58EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#0075FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24A5FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.9c6cb274baccc1b450ae41f23130ac90.svg";
export { ForwardRef as ReactComponent };